import * as __model from '../model';

export class Offer {
  pageIndex?: number;
  pageSize?: number;
  count?: number;
  data: __model.OfferData[];
}

